import { docsHref } from '../docsPaths';

const references = [
  {
    title: 'Management API Reference',
    href: docsHref('/api/management'),
    description:
      'Use service-account automation for organizations, projects, rooms, tournaments, webhooks, tournament result verification, embeds, and support evidence.',
    prefixes: ['pw_mgmt_'],
  },
  {
    title: 'Calculation API Reference',
    href: docsHref('/api/calculations'),
    description:
      'Use product-key calls for deterministic poker calculations, metered simulations, usage reads, and health checks.',
    prefixes: ['pw_test_', 'pw_live_'],
  },
];

export function ApiReferenceHub() {
  return (
    <div className="pw-docs-card-grid" aria-label="API reference choices">
      {references.map((reference) => (
        <a className="pw-docs-card" href={reference.href} key={reference.href}>
          <span className="pw-docs-card-copy">
            <strong>{reference.title}</strong>
            <small>
              {reference.description}{' '}
              {reference.prefixes.map((prefix, index) => (
                <span key={prefix}>
                  {index > 0 ? ' / ' : null}
                  <code>{prefix}...</code>
                </span>
              ))}
            </small>
          </span>
        </a>
      ))}
    </div>
  );
}
